module.exports = __webpack_public_path__ + "assets/img/mecha-btn-021cd245.png";